import React from "react";

const STYLES = {
  PENDIENTE: "bg-[#FDF3E1] text-[#A6751F] border-[#F0DEB2]",
  CONFIRMADO: "bg-[#E9EBE4] text-[#545848] border-[#D5D8CD]",
  ENTREGADO: "bg-[#DAE6D7] text-[#3F6B3C] border-[#BCD3B7]",
  CANCELADO: "bg-[#FBEBEB] text-[#8E2E2E] border-[#F0CECE]",
  // legacy fallbacks (just in case)
  OK: "bg-[#E9EBE4] text-[#545848] border-[#D5D8CD]",
  REVISAR: "bg-[#FDF3E1] text-[#A6751F] border-[#F0DEB2]",
  BORRADOR: "bg-[#F0F0F0] text-[#595959] border-[#E0E0E0]",
};

const LABELS = {
  PENDIENTE: "Pendiente",
  CONFIRMADO: "Confirmado",
  ENTREGADO: "Entregado",
  CANCELADO: "Cancelado",
};

export default function EstadoBadge({ estado }) {
  const cls = STYLES[estado] || STYLES.PENDIENTE;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-[0.12em] border ${cls}`}
      data-testid={`estado-${estado}`}
    >
      {LABELS[estado] || estado}
    </span>
  );
}
